module.exports = __webpack_public_path__ + "static/media/ch-box-0-norm.ebedb0a7.svg";